export const routeModalHeaderClassName = "position-relative";

const RouteModalCloseButton = ({ onClick, ariaLabel = "Close modal" }) => (
  <i
    className="fa-solid fa-xmark close-container"
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") onClick?.();
    }}
    aria-label={ariaLabel}
  />
);

export default RouteModalCloseButton;
